import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { Observable } from 'rxjs';

@Component({
  selector: 'student-navigator',
  template: require('./student-navigator.component.html'),
  styles: [require('./student-navigator.component.scss')],
})
export class StudentNavigatorComponent implements OnInit {
  public studentsCount: number;
  public studentNumber: number;

  @Input() students; // Flattened Students

  studentNavigationControl: FormControl = new FormControl();
  options = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;

  constructor(
    @Inject('$stateParams') private $stateParams: IStateParamsService,
    @Inject('$state') private $state: IStateService,
  ) {}

  ngOnInit() {
    this.studentsCount = this.getStudentsCount();
    this.studentNumber = this.getStudentNumber();
  }

  private getStudentsCount(): number {
    const studentsCount = this.students.length;

    return studentsCount;
  }

  private getStudentId() {
    const { studentId } = this.$stateParams;

    return studentId;
  }

  private getStudentNumber(): number {
    const studentId = this.getStudentId();
    const _findStudent = this.findStudent.bind(null, studentId);
    const studentNumber = this.students.findIndex(_findStudent) + 1;

    return studentNumber;
  }

  private findStudent(studentId, student) {
    const { _id } = student;
    const studentIsMatch = _id === studentId;

    return studentIsMatch;
  }

  public nextStudent() {
    const thereIsNextStudent = this.studentNumber < this.students.length;

    if (thereIsNextStudent) {
      const indexOfNextStudent = this.studentNumber;
      const nextStudent = this.students[indexOfNextStudent];
      const nextStudentId = nextStudent._id;

      this.$state.go('main.school.single-student', { studentId: nextStudentId });
    }
  }

  public prevStudent() {
    const thereIsPrevStudent = this.studentNumber > 1;

    if (thereIsPrevStudent) {
      const indexOfPrevStudent = this.studentNumber - 2;
      const prevStudent = this.students[indexOfPrevStudent];
      const prevStudentId = prevStudent._id;

      this.$state.go('main.school.single-student', { studentId: prevStudentId });
    }
  }
}
